export default __webpack_public_path__ + "static/media/illustrator.956c8630.svg";